// RadialProgress.tsx
import React from "react";
import questionIcon from "../../assets/question_icon_peak.png";

interface RadialProgressProps {
  value: number;
  size?: string;
  thickness?: string;
  color?: string;
  showValue?: boolean;
  text?: string;
  textSize?: string;
}

const RadialProgress: React.FC<RadialProgressProps> = ({
  value,
  size = "3rem",
  thickness = "8px", // Increased from 4px to 8px for thicker appearance
  color = "text-primary",
  showValue = true,
  text = "text",
  textSize = "text-3xl",
}) => {
  const style = {
    "--value": value,
    "--size": size,
    "--thickness": thickness,
    boxShadow: `inset 0 0 0 ${thickness} transparent`, // Transparent unfilled ring
    transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)", // Smooth transition for value changes
  } as React.CSSProperties;

  return (
    <div
      className={`radial-progress ${color} bg-base-100/40 backdrop-blur-lg flex items-center justify-center`}
      style={style}
      aria-valuenow={value}
      role="progressbar"
    >
      {text === "?" ? (
        <img
          src={questionIcon}
          alt="Question"
          className="w-16 h-16 object-contain"
        />
      ) : (
        <span
          className={`font-bold text-base-content ${textSize} font-grotesk transition-all duration-300 flex items-center justify-center text-center`}
        >
          {showValue && `${text}`}
        </span>
      )}
    </div>
  );
};

export default RadialProgress;
